// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkInProgress_wrapper__3WO9z"};